import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { registerLicense } from '@syncfusion/ej2-base';

registerLicense("Ngo9BigBOggjHTQxAR8/V1NDaF5cWWtCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWH5cdXVcR2BYVk13WUI=")
export function getBaseUrl() {
  if (environment.production)
  {
  return document.getElementsByTagName('base')[0].href;
  }
  else
  {
  // return document.getElementsByTagName('base')[0].href;
  return 'https://localhost:7239/';
  // return 'https://localhost:7240/';
}
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic(providers).bootstrapModule(AppModule)
  .catch(err => console.log(err));

